module.exports = __webpack_public_path__ + "3289f7c0221002befbad921b0f154135.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-16.png
// module id = 2178
// module chunks = 0